import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ThemedBackground = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  return (
    <div className="fixed inset-0 overflow-hidden bg-transparent">
      {/* Modern gradient background */}
      <div 
        className={`absolute inset-0 ${
          isDark 
            ? 'bg-gradient-to-br from-slate-950 via-slate-900 to-primary-950' 
            : 'bg-gradient-to-br from-white via-slate-50 to-primary-50'
        }`}
      />
      
      {/* Subtle gradient overlay */}
      <div 
        className={`absolute inset-0 opacity-30 ${
          isDark 
            ? 'bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary-900/20 via-transparent to-transparent' 
            : 'bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary-200/50 via-transparent to-transparent'
        } bg-[length:200%_200%]`}
      />
    </div>
  );
};

export default ThemedBackground;
